import { useTranslation } from 'react-i18next'
import * as z from 'zod'

export const useCreateNewCryptoWalletAddressSchema = () => {
  const { t } = useTranslation()

  const createNewCryptoWalletAddressSchema = z.object({
    addressName: z
      .string()
      .max(50, t('api:validationErrors.maxLength', { count: 50 }))
      .optional()
      .or(z.literal('')),
    address: z
      .string()
      .min(1, t('api:validationErrors.required'))
      .min(20, t('api:validationErrors.minLength', { count: 20 }))
      .max(100, t('api:validationErrors.maxLength', { count: 100 }))
      .refine((val) => val.trim().length > 0, {
        message: t('api:validationErrors.required'),
      }),
  })

  return createNewCryptoWalletAddressSchema
}

export type ICreateNewCryptoWalletAddressSchema = z.infer<
  ReturnType<typeof useCreateNewCryptoWalletAddressSchema>
>
